import { render, staticRenderFns } from "./ChannelAnalyticsFilters.vue?vue&type=template&id=23b0a674&"
import script from "./ChannelAnalyticsFilters.vue?vue&type=script&lang=js&"
export * from "./ChannelAnalyticsFilters.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAnalyticsFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports